import React from 'react';
import {createUser} from "../../store/actions/user";
import {connect} from "react-redux";
import {
    addPaymentMethodAndBuy,
    addPaymentMethodAndBuyBundle,
    createPaymentIntent
} from "../../store/actions/transactions";
import Stripe from "../Stripe/Stripe";
import {DEFAULT_PAYMENT_PROVIDER} from "../../shared/config";
import {sendAnalytics} from "../../store/actions/analytics";
import * as event from '../../shared/analyticEvents';
import classes from "./CreditCardForm.module.css";
import $ from 'jquery';
import cardServices from "../../shared/util/cardServices";

class CreditCardForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            token: '',
            cvv: '',
            exp: ''
        };
    }


    componentDidMount() {
        if (this.props.orderForm) {
            const {orderForm: {transactionId}} = this.props || false;
            if (transactionId && !this.props.paymentIntent && !this.props.finishedTransactions) {
                this.props.createPaymentIntent(transactionId);
            }
        }
        cardServices.init()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
    }

    buy(token, provider) {
        const transactions = this.props.cart.map(item => {
            return {
                userId: this.props.user.id,
                productId: item.id,
                paymentProvider: provider,
                marketingCampaign: "Web Store",
                couponCode: this.props.coupon ? this.props.coupon.code : null,
                metadata: {
                    purchasedFrom: document.URL
                }
            }
        });
        this.props.buy(this.props.user.id, token, provider, transactions);
        localStorage.setItem('userId', `${this.props.user.id}`);
        this.props.sendAnalytics(event.SUBMIT_CREDIT)

    }

    handleTokenChange(token) {
        this.setState({
            token: token
        });
    }

    submitCreditForm = () => {
        const cartItems = this.props.cart
        const token = localStorage.getItem('token')
        const exp = $.trim($("#exp").val());
        const customerId = localStorage.getItem('user')
        const cvv = $.trim($("#cvvc").val());
        const postal = $.trim($("#postal").val());
        this.props.buy(customerId, token, exp, cvv, cartItems, postal)
    }

    render() {

        if (this.props.finishedTransactions) {
            this.props.handleCreditCardPurchase();
        }
        let form = <h2>Something went wrong, please contact customer support</h2>;

        if (DEFAULT_PAYMENT_PROVIDER === "BRAINTREE") {
            form = <div>
                <div id="card_container" className="cd-container">
                    <div className="cc-logo">
                        <i className="fa fa-credit-card"/>
                    </div>
                    <div id="_working">Working...</div>
                    <div className="cd-row">
                        <div className="cd-title">
                            <div className="cd-title-label">
                                Card Number
                            </div>
                        </div>
                        <div className="cd-field">
                            <iframe title="tokenframe" id="tokenframe" name="tokenframe" frameBorder="0"
                                    scrolling="no"/>
                        </div>
                    </div>
                    <div id="cc_error" className="cd-err-row hidden">
                        Please enter a valid credit card number
                    </div>
                    <div className="cd-row">
                        <div className="cd-title">
                            <div className="cd-title-label">
                                Expiration <small>(mmyy)</small>
                            </div>
                        </div>
                        <div className="cd-field">
                            <input id="exp" className="cd-input" type="text"/>
                        </div>
                    </div>
                    <div className="cd-row">
                        <div className="cd-title">
                            <div className="cd-title-label">
                                CVVC
                            </div>
                        </div>
                        <div className="cd-field">
                            <input id="cvvc" className="cd-input" type="text"/>
                        </div>
                    </div>
                    <div className="cd-row">
                        <div className="cd-title">
                            <div className="cd-title-label">
                                Zip
                            </div>
                        </div>
                        <div className="cd-field">
                            <input required={true} id="postal" className="cd-input" type="text"/>
                        </div>
                    </div>
                </div>
                <div className="cd-button-container">
                    <div className="cd-row button-row">
                        <button
                            onClick={() => this.submitCreditForm()}
                            id="btn_submit" type="button" className="btn btn-primary btn-lg btn-block">Add Credit
                            Card
                        </button>
                    </div>
                </div>
                <div className="cd-button-container">
                    <div className="cd-row button-row">
                        <div id="myToken"/>
                    </div>
                </div>

            </div>
        } else if (DEFAULT_PAYMENT_PROVIDER === "STRIPE") {
            form = <Stripe onSubmit={(token) => this.buy(token, "STRIPE")}/>
        }
        if (this.props.paymentIntent !== null) {
            form = <Stripe
                onSubmit={(token) => this.props.buyBundle(token, "STRIPE", this.props.userId, this.props.cuId)}/>
        }

        return (

            <React.Fragment>
                <div className={classes.cardComponentBox}>
                    {form}
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        coupon: state.couponReducer.coupon,
        loading: state.transactionsReducer.loading,
        createdTransactions: state.transactionsReducer.created,
        finishedTransactions: state.transactionsReducer.finished,
        error: state.transactionsReducer.error,
        cart: state.cartReducer.cart,
        user: state.userReducer.data,
        cuId: state.transactionsReducer.cuId,
        orderForm: state.corporateBundleReducer.orderForm,
        paymentIntent: state.transactionsReducer.paymentIntent
    };
};

const mapDispatchToProps = dispatch => {
    return {
        createUser: (userInfo) => dispatch(createUser(userInfo)),
        buy: (customerId, token, expiry, cvv, cartItems, postal) => dispatch(addPaymentMethodAndBuy(customerId, token, expiry, cvv, cartItems, postal)),
        buyBundle: (token, provider, userId, cuId) => dispatch(addPaymentMethodAndBuyBundle(token, provider, userId, cuId)),
        createPaymentIntent: (transactionId) => dispatch(createPaymentIntent(transactionId)),
        sendAnalytics: (eventTag) => dispatch(sendAnalytics(eventTag)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreditCardForm);
